import React from 'react';
import { MuiChip } from '@ace/ace-ui-web';

type ChipColor = "green" | "red" | "yellow" | "default" | "black" | "blue" | "purple";

const STATUS_CHIP_CONFIG: Record<string, { colors: ChipColor; label: string }> = {
    ACT: { colors: "green", label: "Active" },
    Active: { colors: "green", label: "Active" },
    INA: { colors: "red", label: "Inactive" },
    Inactive: { colors: "red", label: "Inactive" },
    PND: { colors: "yellow", label: "Pending Activation" },
    Pending: { colors: "yellow", label: "Pending Activation" },
    SUS: { colors: "yellow", label: "Suspended" },
    Suspended: { colors: "yellow", label: "Suspended" },
};

const SHIFT_STATUS_ABBREVIATIONS: Record<string, string> = {
    'Approved': 'Appr',
    'Pending Approval': 'Pend',
    'Rejected': 'Rej',
};

export const getShiftStatusAbbreviation = (status: string): string =>
    SHIFT_STATUS_ABBREVIATIONS[status] ?? status;

export const INACTIVE_STATUSES = new Set(["INA", "Inactive", "PND", "Pending"]);

export const getEmployeeStatusChip = (status: string): React.ReactElement => {
    const config = STATUS_CHIP_CONFIG[status];
    return config
        ? <MuiChip colors={config.colors} label={config.label} />
        : <MuiChip colors="default" label={status || "Unknown"} />;
};

export const isInactiveStatus = (status: string): boolean => INACTIVE_STATUSES.has(status);